import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/submissions/${id}/select-saved-feedback`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/selectSavedFeedback.js